$(document).ready(() => {
    $('.main-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: true,
        asNavFor: '.main-slider_thumb',
        prevArrow: '<button class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none"><g clip-path="url(#clip0_104_873)"><path d="M22.276 28.76V31.724L8.86 18.152V16.072L22.276 2.5V5.412L10.68 17.06L22.276 28.76Z" fill="#0A2F2A"/></g><defs><clipPath id="clip0_104_873"><rect width="32" height="32" fill="white" transform="translate(0 32) rotate(-90)"/></clipPath></defs></svg></button>',
        nextArrow: '<button class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none"><g clip-path="url(#clip0_104_870)"><path d="M22.16 16.072V18.152L8.744 31.724V28.76L20.34 17.164L8.744 5.464V2.5L22.16 16.072Z" fill="#0A2F2A"/></g><defs><clipPath id="clip0_104_870"><rect width="32" height="32" fill="white" transform="translate(32) rotate(90)"/></defs></svg></button>'
    });
    $('.main-slider_thumb').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        asNavFor: '.main-slider',
        vertical: true,
        dots: false,
        // centerMode: true,
        focusOnSelect: true,
        prevArrow: false,
        nextArrow: false,
        responsive: [{
            breakpoint: 768,
            settings: {
                vertical: false
            }
        }]
    });
    $(document).on('click', '.swatches_div label.swatches', function () {
        $(this).addClass('active').siblings('label.swatches').removeClass('active')
        $('[media_alt="' + $(this).attr('data-alt') + '"]').click()
        $('.price-container span').html($(this).attr('var_price'))
        $(this).parents('form').find('button.product__add-to-cart [data-price]').html($(this).attr('var_price'))
        $(this).parents('form').find('[name="id"]').val($(this).attr('var_id'))

        rc_hide();

        if($(this).attr('data-rc-hide') != 'true') {
            let rcActiveBox = document.querySelector('.product-rc-box.active');
            let btnPrice = document.querySelector('.product__add-to-cart [data-price]');
            if(rcActiveBox && btnPrice) {
                btnPrice.innerText = formatMoney(parseFloat(rcActiveBox.querySelector('.product-rc-price').dataset.price));
            }
        }

        // let price = parseInt($(this).attr('data-price'));
        // let symbol = $(this).attr('data-currency-symbol');
        // let el_subsave = $('[data-price-subsave]');
        // let el_onetime = $('[data-price-onetime]');

        // if (el_subsave || el_onetime) {
        //     let discount = parseFloat($('[data-label-discount]').text().replace('%', ''));
        //     el_subsave.text(`${symbol}${(price / 100 * (100 - discount) / 100).toFixed(2)}`);
        //     el_onetime.text(`${symbol}${(price / 100).toFixed(2)}`);
        // }
        // if (document.querySelector('.rc_widget__option--active .rc_widget__option__selector')) {
        //     document.querySelector('.rc_widget__option--active .rc_widget__option__selector').click();
        // }
    })

    if ($(".swatches_div").length > 0) {
        let active_swatch = $(".swatches_div .swatches.active");
        if (active_swatch.length == 0) {
            let target_swatch = $(".swatches_div .swatches").eq(0);
            if (target_swatch.length > 0) {
                target_swatch.click();
            }
        }
    }

    if(document.querySelector('.product-recharge-widget-custom')) {
        if(document.querySelector('.product-recharge-widget-custom').dataset.rcDefaultOption == 'onetime') {
            document.querySelector('.product-rc-box.rc-plan-onetime .product-rc-button').click();
        }
    }

    rc_hide(true);

    function rc_hide(is_first = false) {
        let rc_widget = $(".product-recharge-widget-custom");
        if(!rc_widget) return;
        let active_swatch = $(".swatches_div .swatches.active");
        if (active_swatch.attr('data-rc-hide') == 'true') {
            rc_widget.removeClass('visible');
        } else {
            rc_widget.addClass('visible');
            if(is_first && document.querySelector('.product-recharge-widget-custom .product-rc-box.active .product-rc-button')) {
                document.querySelector('.product-recharge-widget-custom .product-rc-box.active .product-rc-button').click();
            }
        }
    }

    $(document).on('click', '[data-btn-add-to-bag2]', async function (e) {
        // var formData = $(this).parents('form').serialize();
        // var title = $(this).parents('.container.product__container').find('h1.h5.text-forest.uppercase').attr('title');
        // var image = $(this).parents('form').find('.swatches_div label.swatches.active').attr('image');

        let form = e.target.closest('form');
        let id = form.querySelector('input[name="id"]').value;
        let selling_plan = '';

        let activeRechargeWidget = document.querySelector('.product-recharge-widget-custom.visible');
        if(form.querySelector('.rc-plan-subscription.active') && activeRechargeWidget) {
            selling_plan = form.querySelector('.rc-plan-subscription.active .product-rc-plan-button.active').dataset.planId;
        }

        const response = await fetch(`/cart/add.js`, {
            method: 'POST',
            body: JSON.stringify({
              id: id,
              quantity: 1,
              selling_plan: selling_plan
            }),
            headers: {
                'Content-Type': 'application/json'
            }
        });
        const json = await response.json();
        await updateCartDrawer();
        await handleGwp();
        if(document.querySelector('upsell-popup')) {
            document.querySelector('upsell-popup').classList.add('open');
        }
    });

    
    function atc(data, image, title) {
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: data,
            dataType: 'json',
            success: async function (response) {
                await updateCartDrawer();
                await handleGwp();
                if(document.querySelector('upsell-popup')) {
                    document.querySelector('upsell-popup').classList.add('open');
                }
            },
            error: function (xhr, status, error) {
                // Handle the error response
                console.error('Error adding product to cart:', error);
                // Display error messages or perform error handling
            }
        });
    }

    var inp_cc = $('.product-form__input.quantity-main input:checked').attr('value');
    $('ul.thumbnail-list.thumb-product li').each(function () {
        var thumb = $(this).attr('opmatch');
        console.log(thumb);
        if (thumb == inp_cc) {
            $(this).show();
        } else {
            $(this).hide();
        }
    })
});
$('.bundlee [data-open-collapsible-card]').click(function () {
    $(this).toggleClass('active')
    if ($(this).next().attr('hidden')) {
        $(this).next().removeAttr('hidden')
    } else {
        $(this).next().attr('hidden', '')
    }
})
$('label.click-find').click(function () {
    var getit = $(this).attr('data-op');
    console.log(getit);
    $('ul.thumbnail-list.thumb-product li').each(function () {
        var thumb = $(this).attr('opmatch');
        console.log(thumb);
        if (thumb == getit) {
            $(this).show();
        } else {
            $(this).hide();
        }
    })
});

if (window.matchMedia("(min-width: 768px)").matches) {
    $(document).scroll(function () {
        var y = $(this).scrollTop();
        if (y > 700) {
            $('.sticky-add-to-cart').addClass('viewaddcart');
        } else {
            $('.sticky-add-to-cart').removeClass('viewaddcart')
        }
    });
}

if (window.matchMedia("(max-width: 767px)").matches) {
    $(document).scroll(function () {
        var y = $(this).scrollTop();
        if (y > 1400) {
            $('.sticky-add-to-cart').addClass('viewaddcart');
        } else {
            $('.sticky-add-to-cart').removeClass('viewaddcart')
        }
    });
}


$(document).on('click', '.sticky-button-just', function () {
    var ID = $(this).parents('.sticky-add-to-cart__form').find('.var-dropdown select.product-form__variants option:checked').attr('value');
    var plan = $(this).parents('.sticky-add-to-cart__form').find('.selling-plans select option:checked').attr('value');
    var title = $(this).parents('.sticky-add-to-cart__form').find('select.product-form__variants option:checked').attr('title');
    var image = $(this).parents('.sticky-add-to-cart__form').find('select.product-form__variants option:checked').attr('image');
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
            quantity: 1,
            id: ID,
            selling_plan: plan
        },
        dataType: 'json',
        success: function () {
            console.log('success');
            $.ajax({
                type: 'GET',
                url: '/cart.json',
                dataType: 'json',
                success: function (cart) {
                    console.log(cart);
                    $('[data-cart-qty]').html(cart.item_count)
                }
            });
            $('.mini-cart-modal').addClass('is-active');
            $('.mini-cart-modal__item img').attr('src', image);
            $('.mini-cart-modal__item h5').html(title);
        }
    });
});

$('.product-car-variant span').click(function () {
    $(this).addClass('active').siblings().removeClass('active');
    var id = $(this).attr('value');
    var price = $(this).attr('price');
    // var title = $(this).attr('title');
    var image = $(this).attr('img-src');
    // $(this).parents('li.collection-grid__item').find('.card-product__price.button span.text-lg').attr('data-product-id',id);
    $(this).parents('li.collection-grid__item').find('button.newproduct-btn').attr('data-product-id', id);
    $(this).parents('.card-product__item.sd').find('.newproduct-btn').attr('data-product-id', id);
    $(this).parents('.card-product__item.sd').find('.newproduct-btn').attr('data-img-src', image);
    $(this).parents('li.collection-grid__item').find('button.newproduct-btn').attr('data-img-src', image);
    // $(this).parents('li.collection-grid__item').find('.card-product__price.button span.text-lg').attr('data-img-title',title);
    // $(this).parents('li.collection-grid__item').find('button.newproduct-btn').attr('data-img-title',title);
    let g_discount_btn = $(this).parents('.card-product-item').find('.newproduct-btn[data-global-discount]');
    if(g_discount_btn.length > 0) {
        var dataPrice = parseFloat($(this).attr('data-price'));
        var percent = (100 - parseFloat(g_discount_btn.attr('data-global-discount'))) / 100.0;
        price = dataPrice * percent;
        $(this).parents('.card-product-item').find('span.only-pp').html(formatMoney(price).replace('.00', ''));
        $(this).parents('.card-product-item').find('span.compare_price').html(formatMoney(dataPrice).replace('.00', ''));
    }
    else {
        $(this).parents('li.collection-grid__item').find('span.only-pp').html(price);
        $(this).parents('.card-product__item.sd').find('span.only-pp').html(price);
    }
});

$('.newproduct-btn, .product-card-cta').click(function (e) {
    e.preventDefault();
    var title = $(this).attr('data-img-title');
    var image = $(this).attr('data-img-src');
    var id = $(this).attr('data-product-id');

    let data = {
        items: [
            {
                id: id,
                quantity: 1
            }
        ]
    }
    atc_item(data, image, title);
});

function atc_item(data, image, title) {
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json',
        success: async function (cart) {
            await updateCartDrawer();
            await handleGwp();
            
            if(document.querySelector('upsell-popup')) {
                document.querySelector('upsell-popup').classList.add('open');
            }
        }
    });
}


$('body.landing_page .slider_main_here').slick({
    slidesToShow: 6,
    slidesToScroll: 1,
    speed: 8000,
    autoplay: true,
    autoplaySpeed: 0,
    centerMode: false,
    cssEase: 'linear',
    infinite: true,
    initialSlide: 1,
    arrows: false,
    buttons: false,
    responsive: [{
        breakpoint: 1440,
        settings: {
            slidesToShow: 5,
            slidesToScroll: 1
        }
    },
    {
        breakpoint: 1080,
        settings: {
            slidesToShow: 4,
            slidesToScroll: 1
        }
    },
    {
        breakpoint: 767,
        settings: {
            slidesToShow: 1,
            slidesToScroll: 1
        }
    }
    ]
});